const init = {
    status:false,
    message:'',
    data:{}
}

export const getOrganizationsReducer = (state = init, action) => {
    switch (action.type){
        case 'GET_ORGANIZATION_START':
            return state;
        case 'GET_ORGANIZATION_FAIL':
            return {...state, message:action.payload.message,status:false};
        case 'GET_ORGANIZATION_EXCEPTION':
            return {...state, message:action.payload,status:false};
        case 'GET_ORGANIZATION_SUCCESS':
            return {...state, data:action.payload.data, status:true };
        default:
            return state;
    }
};